module.exports = __webpack_public_path__ + "5d9a75270a4dc7a127ce7cfea1bb4295.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/slider/slider-1.png
// module id = ./assets/images/slider/slider-1.png
// module chunks = 0